import { useMemo } from "react";

export const useQueryParams = () => {
  const queryParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [],
  );

  const isRoutingMode = queryParams.get("routing") !== "disable";
  const isDebugMode = queryParams.get("debug") === "enable";
  const isTimeoutMode = queryParams.get("timeout") !== "false";
  const routeFeatureId = queryParams.get("feature");
  const qsSearchTagId = queryParams.get("search_tag_id");
  const qsSearchTagType = queryParams.get("search_tag_type");

  return {
    isRoutingMode,
    isDebugMode,
    isTimeoutMode,
    routeFeatureId,
    qsSearchTagId,
    qsSearchTagType,
    queryParams,
  };
};
